export type AbsolutePath = `/${string}`;

type InputData<PathConfig, Key> = Key extends keyof PathConfig ? PathConfig[Key] : void;

type InputDataOrVoid<PathConfig, Key> = InputData<PathConfig, Key> extends void ? void : InputData<PathConfig, Key>;

/** A config of optional keys only (a list's `filters`) may be left out: `tireHotels.getPath()`. */
type GetPathArgs<Input> = Input extends void ? [data: Input] : object extends Input ? [data?: Input] : [data: Input];

type RouteDefinition<PathConfig, Key> = {
  getPath(...args: GetPathArgs<InputDataOrVoid<PathConfig, Key>>): AbsolutePath;
  getBasePath(): AbsolutePath;
};

/**
 * Types a route table from its own keys: `getPath` for a key present in
 * `PathConfig` takes that config, every other key takes no argument. Replaces
 * the hand-maintained key registry each app used to keep next to its routes.
 */
export const defineRoutes =
  <PathConfig>() =>
  <Routes extends { [Key in keyof Routes]: RouteDefinition<PathConfig, Key> }>(routes: Routes): Routes =>
    routes;
